import React, { Fragment } from 'react';
import { Card, Col, Row } from 'antd';
import { currencyVND, dateToString } from '../../../../utils';

export default ({ customer }) => {

	const InfoRow = ({ label, value }) => (
		<Row style={{ marginBottom: 8 }}>
			<Col span={10} >{label}</Col>
			<Col span={14}>: {value || '---'}</Col>
		</Row>
	);

	return <Fragment>
		<Card title="Thông tin mua hàng">
			<Row>
				<Col span={12}>
					<InfoRow label="Tổng chi tiêu" value={currencyVND(customer.totalInvoice) || '---'} />
					{/*<InfoRow label="Mã barcode" value={product.barcode} />*/}
					<InfoRow label="Tổng SL đơn hàng" value={customer.totalOrder || '---'} />
					<InfoRow label="Ngày cuối cùng mua hàng" value={dateToString(customer.latestOrder, 'DD-MM-YYYY')|| '---'} />
					{/*<InfoRow label="Phân loại" value={product.isNormal ? <Tag color="magenta">Sản phẩm thường</Tag> : <Tag color="green">Serial/IMEI</Tag>} />*/}
					{/*<InfoRow label="Tình trạng sử dụng" value={GENDER_OBJ[customer.gender] || '---'} />*/}
				</Col>
				<Col span={12}>
					{/*<InfoRow label="Tổng SL sản phẩm đã mua" value={'---'} />*/}
					{/*<InfoRow label="Tổng SL sản phẩm hoàn trả" value={'---'} />*/}
					{/*<InfoRow label="Tags" value="---" />*/}
					<InfoRow label="Công nợ hiện tại" value={currencyVND(customer.totalDebt)} />
				</Col>
			</Row>
		</Card>
	</Fragment>;
}
